import React from "react";

import { AddendumDisplay } from "@/features/addendum/components/AddendumDisplay";
import { Button2 } from "@/ui2/atoms/Button";
import CardSecondary from "@/components/UI/Card/CardSecondary";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { GuidedSessionView } from "@/features/notes/(v2)/(guided-session)/GuidedSessionView";
import { PrescriberMedications } from "@/features/notes/(v2)/(guided-session)/components/MemberProfileNotesMedications";

import { PatientInfoWidget } from "./PatientInfoWidget";

const NO_PREVIOUS_NOTE_MESSAGE = (
  <CardSecondary className="pt-4 px-4 m-3 ml-auto mr-auto w-100 color-black text-center">
    No previous guided session with current patient. Please complete a guided session note to
    display.
  </CardSecondary>
);

const behavioralReviewLastNotes = (componentProps) => {
  const { jumpWorkflowStep, state } = componentProps;
  const { addendums, lastNote, lastNotesOther, patientDetails, patientDiagnosis } = state;

  let lastPrescriberNote = lastNotesOther["PRESCRIBE"];

  if (!lastPrescriberNote || !lastPrescriberNote.version || lastPrescriberNote.version === 1) {
    lastPrescriberNote = {
      content: {
        medications: [],
      },
    };
  }

  let currentMedicationDisplay = <PrescriberMedications note={lastPrescriberNote} />;

  let noteDisplay;

  if (!lastNote) {
    noteDisplay = NO_PREVIOUS_NOTE_MESSAGE;
  } else {
    noteDisplay = (
      <>
        <div className="mt-3 ml-auto mr-auto tw:font-bold" style={{ maxWidth: "90%" }}>
          {lastNote.title}
        </div>

        {currentMedicationDisplay}

        <div className="m-auto">
          <GuidedSessionView note={lastNote} />
        </div>

        {addendums.map((addendum) => (
          <AddendumDisplay
            addendum={addendum.addendum}
            key={addendum.timestamp}
            style={{ margin: "10px auto", maxWidth: "50%", minHeight: 0 }}
            timestamp={addendum.timestamp}
          />
        ))}
      </>
    );
  }

  return (
    <div className="GuidedVideoCall__notes_screen">
      <PatientInfoWidget
        isLarger={true}
        patientDetails={patientDetails}
        patientDiagnosis={patientDiagnosis}
      />

      {noteDisplay}

      <div className="my-3 position-relative w-100 text-center">
        <Button2
          onPress={() => jumpWorkflowStep(state.currentStep + 1)}
          {...getAutomationDataAttr("ReviewLastNotes_beginSession")}
        >
          Begin Session
        </Button2>
      </div>
    </div>
  );
};

export const BehavioralReviewLastNotes = React.memo(behavioralReviewLastNotes);

const prescribeReviewLastNotes = (componentProps) => {
  const { jumpWorkflowStep, state } = componentProps;
  const { addendums, lastNote, patientDetails, patientDiagnosis } = state;

  let noteDisplay;

  if (!lastNote) {
    noteDisplay = NO_PREVIOUS_NOTE_MESSAGE;
  } else {
    noteDisplay = (
      <>
        <div className="mt-3 ml-auto mr-auto tw:font-bold" style={{ maxWidth: "90%" }}>
          {lastNote.title}
        </div>

        <div className="m-auto">
          <GuidedSessionView note={lastNote} />
        </div>

        {addendums.map((addendum) => (
          <AddendumDisplay
            addendum={addendum.addendum}
            key={addendum.timestamp}
            style={{ margin: "10px auto", maxWidth: "50%", minHeight: 0 }}
            timestamp={addendum.timestamp}
          />
        ))}
      </>
    );
  }

  return (
    <div className="GuidedVideoCall__notes_screen">
      <PatientInfoWidget
        isLarger={true}
        patientDetails={patientDetails}
        patientDiagnosis={patientDiagnosis}
      />

      {noteDisplay}

      <div className="my-3 position-relative w-100 text-center">
        <button
          className="GuidedVideoCall__center-btn fs-14"
          onClick={() => jumpWorkflowStep(state.currentStep + 1)}
        >
          Begin Session
        </button>
      </div>
    </div>
  );
};

export const PrescribeReviewLastNotes = React.memo(prescribeReviewLastNotes);
